
import { useEffect, useState } from 'react'
import './style.scss'
import '../styles/admintab.scss'
import { useAppSelector } from '../../redux/hooks'
import { ChatInteractions, UserData } from '../../server/types'
import { getProfilePicPath } from '../../constants/instructorConstants'
import { adminStateData } from '../../data/adminStateData'
import { InteractionStatus } from '../../types/types'
import { getBookingStatusLabel } from '../../utils/RetrieveStrings'
import { PAGE_URLS } from '../../constants/hrefLinks'

function AdminChatsContentArea() {
	const [tabIndex, setTabIndex] = useState<number>(0)
	const [interactions, setInteractions] = useState<ChatInteractions[]>([])
	const [adminDataLoaded, setAdminDataLoaded] = useState<boolean>(false)

	const dataLoadRequestFinished: boolean = useAppSelector(state => state.user.dataLoadRequestFinished)

	const STATUS_TABS: string[] = ['All', 'Active', 'Complete', 'Flagged', 'Payment Failed', 'Waiting Video', 'Review']

	const TAB_STATUSES: string[] = ['', InteractionStatus.ACTIVE, InteractionStatus.COMPLETE, InteractionStatus.FLAGGED, InteractionStatus.PAYMENT_FAILED, InteractionStatus.WAITING_FOR_VIDEOS, InteractionStatus.REVIEW]

	useEffect(() => {
		if (dataLoadRequestFinished === true) {
			setAdminDataLoaded(true)
			setInteractions(adminStateData.getInteractions())
			setTabIndex(0)
		}
	}, [dataLoadRequestFinished])

	const tabClickHandler = (newIndex: number) => {
		if (newIndex === 0) {
			setInteractions(adminStateData.getInteractions())
		} else {
			setInteractions(adminStateData.getInteractionsWithStatus(TAB_STATUSES[newIndex]))
		}
		setTabIndex(newIndex)
	}

	return (
		<div className='dashboard-content-area-wrap'>
			{adminDataLoaded &&
				<div className='dashboard-content-area-wide-card-wrap'>
					<div className='dashboard-content-area-card'>
						<div className='admin-tab-wrap'>
							{STATUS_TABS.map((tab: string, index: number) => 
								<div 
									className={`admin-tab-item ${tabIndex === index ? 'admin-tab-item-active' : ''}`}
									key={`tablabel${index}`}
									onClick={() => tabClickHandler(index)}
								>{tab}</div>
							)}
						</div>
						<div
							className='dashboard-content-area-card-content'
						>
							{interactions.length === 0 ?
								<span>No Chats</span>
								:
								interactions.map((booking: ChatInteractions, index: number) => 
									<a 
										className='dashboard-content-area-card-chat-wrap'
										key={`chatItem${index}`}
										href={`${PAGE_URLS.ADMIN_CHAT}?id=${booking.id}`}
									>
										<img
											className='dashboard-content-area-card-chat-img'
											alt='profile thumbnail'
											src={booking.otherUserDetails?.profile_pics ? getProfilePicPath(booking.otherUserDetails?.profile_pics, 0) : undefined}
										/>
										<div className='dashboard-content-area-card-chat-details-wrap'>
											<div className='dashboard-content-area-card-chat-name'>{booking.otherUserDetails?.name}</div>
										</div>
										<div className='dashboard-content-area-booking-status'>
											{getBookingStatusLabel(booking.status)}
										</div>
										<div className='dashboard-content-area-booking-cost'>
											$ {(parseFloat(booking.price ? booking.price : '0') / 100).toFixed(2)}
										</div>
									</a>
								)
							}
						</div>
					</div>
				</div>
			}
		</div>
	)
}

export default AdminChatsContentArea
